/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable lodash/prefer-constant */

import React, { createContext, useContext } from 'react';
import type { RemoteModuleRegistry, Events } from '@dutchiesdk/ecommerce-extensions-sdk';

type FallbackProps = { fallback?: React.FC<any> };
type DefaultComponentSig = (options?: FallbackProps) => React.FC<any>;

export type RouteablePage = {
  path: string;
  component: DefaultComponentSig;
};

export type CommerceComponents = {
  components: {
    [K in keyof Omit<
      RemoteModuleRegistry,
      'events' | 'getStoreFrontMetaFields' | 'RouteablePages' | 'StoreFrontCarouselInterstitials'
    >]-?: DefaultComponentSig;
  };
  findPage: (o: { fallback?: React.FC; path?: string }) => React.FC;
  iterables: {
    StoreFrontCarouselInterstitials: () => React.ElementType[];
  };
  pages: ({ fallback }: FallbackProps) => RouteablePage[];
  events: Events | undefined;
};

function EmptyComponent(): JSX.Element {
  return <></>;
}

export const defaultCommerceComponents: CommerceComponents = {
  components: {
    StoreFrontHeader: ({ fallback = EmptyComponent }: FallbackProps) => fallback,
    StoreFrontMeta: ({ fallback = EmptyComponent }: FallbackProps) => fallback,
    StoreFrontNavigation: ({ fallback = EmptyComponent }: FallbackProps) => fallback,
    StoreFrontFooter: ({ fallback = EmptyComponent }: FallbackProps) => fallback,
    StoreFrontHero: ({ fallback = EmptyComponent }: FallbackProps) => fallback,
    ProductDetailsPrimary: ({ fallback = EmptyComponent }: FallbackProps) => fallback,
    ProductDetailsMeta: ({ fallback = EmptyComponent }: FallbackProps) => fallback,
  },
  findPage: ({ fallback = () => <></> }) => fallback,
  iterables: {
    StoreFrontCarouselInterstitials: () => [],
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  pages: (_props: FallbackProps = { fallback: () => <></> }) => [],
  events: {},
};

export const CommerceComponentsContext = createContext<CommerceComponents>(defaultCommerceComponents);

export const useCommerceComponents = (): CommerceComponents => useContext(CommerceComponentsContext);
